/////////////////////////////////////////////////////////
// Configurations related to listing.                  //
// Main configuration here is the extended data config //
/////////////////////////////////////////////////////////
//flex-cli search set --key radiusOf --type enum --scope public -m leonardhorsetransport

// Note: The listingFields come from listingFields asset nowadays by default.
//       To use this built-in configuration, you need to change the overwrite from configHelper.js
//       (E.g. use mergeDefaultTypesAndFieldsForDebugging func)

/**
 * Configuration options for listing fields (custom extended data fields):
 * - key:                           Unique key for the extended data field.
 * - scope (optional):              Scope of the extended data can be either 'public' or 'private'.
 *                                  Default option: 'public'.
 *                                  Note: listing doesn't support 'protected' scope atm.
 * - schemaType (optional):         Schema for this extended data field.
 *                                  This is relevant when rendering components and querying listings.
 *                                  Possible values: 'enum', 'multi-enum', 'text', 'long', 'boolean'.
 * - enumOptions (optional):        Options shown for 'enum' and 'multi-enum' extended data.
 *                                  These are used to render options for inputs and filters on
 *                                  EditListingPage, ListingPage, and SearchPage.
 * - listingTypeConfig (optional):  Relationship configuration against listing types.
 *   - limitToListingTypeIds:         Indicator whether this listing field is relevant to a limited set of listing types.
 *   - listingTypeIds:                An array of listing types, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToListingTypeIds is true.
 * - categoryConfig (optional):     Relationship configuration against categories.
 *   - limitToCategoryIds:            Indicator whether this listing field is relevant to a limited set of categories.
 *   - categoryIds:                   An array of categories, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToCategoryIds is true.
 * - filterConfig:                  Filter configuration for listings query.
 *    - indexForSearch (optional):    If set as true, it is assumed that the extended data key has
 *                                    search index in place. I.e. the key can be used to filter
 *                                    listing queries (then scope needs to be 'public').
 *                                    Note: Sharetribe CLI can be used to set search index for the key:
 *                                    https://www.sharetribe.com/docs/references/extended-data/#search-schema
 *                                    Read more about filtering listings with public data keys from API Reference:
 *                                    https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
 *                                    Default option: false,
 *   - filterType:                    Sometimes a single schemaType can be rendered with different filter components.
 *                                    For 'enum' schema, filterType can be 'SelectSingleFilter' or 'enumMultipleFilter'
 *   - label:                         Label for the filter, if the field can be used as query filter
 *   - searchMode (optional):         Search mode for indexed data with multi-enum schema.
 *                                    Possible values: 'has_all' or 'has_any'.
 *   - group:                         SearchPageWithMap has grouped filters. Possible values: 'primary' or 'secondary'.
 * - showConfig:                    Configuration for rendering listing. (How the field should be shown.)
 *   - label:                         Label for the saved data.
 *   - isDetail                       Can be used to hide detail row (of type enum, boolean, or long) from listing page.
 *                                    Default option: true,
 * - saveConfig:                    Configuration for adding and modifying extended data fields.
 *   - label:                         Label for the input field.
 *   - placeholderMessage (optional): Default message for user input.
 *   - isRequired (optional):         Is the field required for providers to fill
 *   - requiredMessage (optional):    Message for those fields, which are mandatory.
 */
export const listingFields = [
  // {
  //   "scope": "public",
  //   "label": "Gears",
  //   "key": "gears",
  //   "schemaType": "long",
  //   "numberConfig": {
  //     "minimum": 1,
  //     "maximum": 24
  //   },
  //   "filterConfig": {
  //     "indexForSearch": true,
  //     "group": "primary",
  //     "label": "Gears"
  //   }
  // }
  // {
  //   key: 'bikeType',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'city-bikes', label: 'City bikes' },
  //     { option: 'electric-bikes', label: 'Electric bikes' },
  //     { option: 'mountain-bikes', label: 'Mountain bikes' },
  //     { option: 'childrens-bikes', label: "Children's bikes" },
  //   ],
  //   categoryConfig: {
  //     limitToCategoryIds: true,
  //     categoryIds: ['cats'],
  //   },
  //   filterConfig: {
  //     indexForSearch: true,
  //     filterType: 'enumMultipleFilter', //'SelectSingleFilter',
  //     label: 'Bike type',
  //     group: 'primary',
  //   },
  //   showConfig: {
  //     label: 'Bike type',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Bike type',
  //     placeholderMessage: 'enum an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to enum a bike type.',
  //   },
  // },
  // {
  //   key: 'tire',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: '29', label: '29' },
  //     { option: '28', label: '28' },
  //     { option: '27', label: '27' },
  //     { option: '26', label: '26' },
  //     { option: '24', label: '24' },
  //     { option: '20', label: '20' },
  //     { option: '18', label: '18' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Tire size',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Tire size',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Tire size',
  //     placeholderMessage: 'enum an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to enum a tire size.',
  //   },
  // },
  // {
  //   key: 'brand',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'cube', label: 'Cube' },
  //     { option: 'diamant', label: 'Diamant' },
  //     { option: 'ghost', label: 'GHOST' },
  //     { option: 'giant', label: 'Giant' },
  //     { option: 'kalkhoff', label: 'Kalkhoff' },
  //     { option: 'kona', label: 'Kona' },
  //     { option: 'otler', label: 'Otler' },
  //     { option: 'vermont', label: 'Vermont' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Brand',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Brand',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Brand',
  //     placeholderMessage: 'enum an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to enum a brand.',
  //   },
  // },
  // {
  //   key: 'accessories',
  //   scope: 'public',
  //   schemaType: 'multi-enum',
  //   enumOptions: [
  //     { option: 'bell', label: 'Bell' },
  //     { option: 'lights', label: 'Lights' },
  //     { option: 'lock', label: 'Lock' },
  //     { option: 'mudguard', label: 'Mudguard' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Accessories',
  //     searchMode: 'has_all',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Accessories',
  //   },
  //   saveConfig: {
  //     label: 'Accessories',
  //     placeholderMessage: 'enum an option…',
  //     isRequired: false,
  //   },
  // },
  // // An example of how to use transaction type specific custom fields and private data.
  // {
  //   key: 'note',
  //   scope: 'public',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['product-selling'],
  //   },
  //   showConfig: {
  //     label: 'Extra notes',
  //   },
  //   saveConfig: {
  //     label: 'Extra notes',
  //     placeholderMessage: 'Some public extra note about this bike...',
  //   },
  // },
  // {
  //   key: 'privatenote',
  //   scope: 'private',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['daily-booking'],
  //   },
  //   saveConfig: {
  //     label: 'Private notes',
  //     placeholderMessage: 'Some private note about this bike...',
  //   },
  // },
];

export const listingFilters = [
  {
    category: 'auto-diesel-mechanic',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'radiusOf',
        label: 'Radius of service',
        type: 'enum',
        options: [
          {
            option: '0 miles',
            label: '0 miles',
          },
          {
            option: '10 miles',
            label: '10 miles',
          },
          {
            option: '25 miles',
            label: '25 miles',
          },
          {
            option: '50 miles',
            label: '50 miles',
          },
          {
            option: '75 miles',
            label: '75 miles',
          },
          {
            option: '75+ miles',
            label: '75+ miles',
          }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Radius of service',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasDieselMechanic',
        label: 'Has diesel mechanic',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Has diesel mechanic',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasBrickAndMortarGarage',
        label: 'Has brick and mortar garage',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Has brick and mortar garage',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Diesel Mechanics Filters
  {
    category: 'diesel-mechanics',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'specificDayOpen',
        label: 'If they are open at a specific day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open on specific days',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'mobileServices',
        label: 'Mobile services',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Mobile services',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'mobileServiceTypes',
        label: 'Mobile service types',
        type: 'multi-enum',
        options: [
          { option: 'emergency-repair', label: 'Emergency Repair' },
          { option: 'preventive-maintenance', label: 'Preventive Maintenance' },
          { option: 'diagnostics', label: 'Diagnostics' },
          { option: 'tire-service', label: 'Tire Service' },
          { option: 'fuel-delivery', label: 'Fuel Delivery' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'tertiary',
          dependance: 'mobileServices',
          dependanceValue: 'true',
          label: 'Mobile service types',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any'
        }
      },
      {
        key: 'mobileResponseTime',
        label: 'Mobile response time',
        type: 'enum',
        options: [
          { option: '1-hour', label: 'Within 1 hour' },
          { option: '2-hours', label: 'Within 2 hours' },
          { option: '4-hours', label: 'Within 4 hours' },
          { option: 'same-day', label: 'Same day' },
          { option: 'next-day', label: 'Next day' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'tertiary',
          dependance: 'mobileServices',
          dependanceValue: 'true',
          label: 'Mobile response time',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'serviceRadius',
        label: 'Service radius',
        type: 'enum',
        options: [
          { option: '0-10', label: '0-10 miles' },
          { option: '10-25', label: '10-25 miles' },
          { option: '25-50', label: '25-50 miles' },
          { option: '50-75', label: '50-75 miles' },
          { option: '75+', label: '75+ miles' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Service radius',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'brickAndMortar',
        label: 'Brick and Mortar Garage',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Brick and Mortar Garage',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'servicesProvided',
        label: 'Services provided',
        type: 'multi-enum',
        options: [
          { option: 'engine-repair', label: 'Engine Repair' },
          { option: 'transmission', label: 'Transmission' },
          { option: 'electrical', label: 'Electrical' },
          { option: 'brakes', label: 'Brakes' },
          { option: 'suspension', label: 'Suspension' },
          { option: 'diagnostics', label: 'Diagnostics' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Services provided',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any'
        }
      }
    ]
  },
  // Farriers Filters CHECK
  {
    category: 'farriers',
    filters: [
      {
        key: 'travelRadius',
        label: 'Travel radius',
        type: 'enum',
        options: [
          {
            option: '0 miles',
            label: '0 miles',
          },
          {
            option: '10 miles',
            label: '10 miles',
          },
          {
            option: '25 miles',
            label: '25 miles',
          },
          {
            option: '50 miles',
            label: '50 miles',
          },
          {
            option: '75 miles',
            label: '75 miles',
          },
          {
            option: '75+ miles',
            label: '75+ miles',
          }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Travel radius',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Feed Stores Filters CHECK
  {
    category: 'feedStores',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Is open 24/7',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Is open 24/7',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'sellHay',
        label: 'Do you sell hay?',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Hay for Sale',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Horse Hotels Filters ALMOST CHECK
  {
    category: 'horse-hotel',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'healthCertificate',
        label: 'Do you require current health certificate',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Health Certificate is required',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'trailerSizeThatCanAccomodate',
        label: 'Trailer size',
        type: 'enum',
        options: [
          { option: 'up-to-25ft', label: 'Up to 25ft' },
          { option: 'up-to-39ft', label: 'Up to 39ft' },
          { option: '39ft-or-larger', label: '39ft or larger' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Trailer size',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'stallTypes',
        label: 'Type of stalls',
        type: 'multi-enum',
        options: [
          { option: 'indoor', label: 'Indoor' },
          { option: 'outdoor', label: 'Outdoor' },
          { option: 'pasture', label: 'Pasture' },
          { option: 'arena', label: 'Arena' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Stall type',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any'
        }
      },
      {
        key: 'numberOfStalls',
        label: 'Number of stalls',
        type: 'enum',
        options: [
          { option: '1-5', label: '1-5 stalls' },
          { option: '6-10', label: '6-10 stalls' },
          { option: '11-20', label: '11-20 stalls' },
          { option: '20+', label: '20+ stalls' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'tertiary',
          dependance: 'stallType',
          dependanceValue: ['indoor', 'outdoor'],
          label: 'Number of stalls',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'horsesSeparated',
        label: 'Horses separated',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'tertiary',
          dependance: 'stallType',
          dependanceValue: ['indoor', 'outdoor'],
          label: 'Horses separated',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'fencingType',
        label: 'Types of fencing',
        type: 'multi-enum',
        options: [
          { option: 'wood', label: 'Wood' },
          { option: 'metal', label: 'Metal' },
          { option: 'electric', label: 'Electric' },
          { option: 'vinyl', label: 'Vinyl' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'tertiary',
          dependance: 'stallType',
          dependanceValue: ['pasture'],
          label: 'Fencing type',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any'
        }
      },
      {
        key: 'arenaType',
        label: 'Is outdoor or indoor',
        type: 'enum',
        options: [
          { option: 'indoor', label: 'Indoor' },
          { option: 'outdoor', label: 'Outdoor' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'tertiary',
          dependance: 'stallType',
          dependanceValue: ['arena'],
          label: 'Arena type',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'heatedBarns',
        label: 'Barns are heated',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Heated barns',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'waterAccess',
        label: 'Water access',
        type: 'multi-enum',
        options: [
          {
            label: 'Auto waterers',
            option: 'autoWaterers',
          },
          {
            label: 'Buckets are provided',
            option: 'bucketsProvided',
          },
          {
            label: 'Must provide your own buckets',
            option: 'mustProvideYourOwnBuckets',
          },
          {
            label: 'No water access. Must provide your own water source.',
            option: 'noWaterAccess',
          },
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Water access',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'sellShavings',
        label: 'Sell shavings',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Shavings for sale',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hayAvailable',
        label: 'Hay is available for purchase',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Hay for sale',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hayIncluded',
        label: 'Hay is included',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Hay included',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'sellStraw',
        label: 'Sell straw',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Straw for sale',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'acceptDrafts',
        label: 'Accept drafts',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Draft horses are accepted',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'rvHookups',
        label: 'RV hookup',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'RV hookups available',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasBunkhouse',
        label: 'Bunkhouse',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Onsite Bunkhouse',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'bunkhouseAmenities',
        label: 'Bunkhouse amenities',
        type: 'multi-enum',
        options: [
          {
            label: 'Bathrooms',
            option: 'bathrooms',
          },
          {
            label: 'Bathroom with shower',
            option: 'bathroomWithShower',
          },
          {
            label: 'Kitchen',
            option: 'kitchen',
          },
          {
            label: 'Living room',
            option: 'livingRoom',
          },
          {
            label: 'Separate bedroom',
            option: 'separateBedroom',
          },
          {
            label: 'Laundry room',
            option: 'laundryRoom',
          },
          {
            label: 'Shared bunkhouse',
            option: 'sharedBunkHouse',
          },
          {
            label: 'Pet friendly',
            option: 'petFriendly',
          },
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'tertiary',
          dependance: 'hasBunkhouse',
          dependanceValue: 'true',
          label: 'Bunkhouse amenities',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any',
          isMadeFrom: [
            {
              option: 'bathrooms',
              label: 'Bathrooms',
              type: 'boolean',
            }, 
            {
              option: 'bathroomWithShower',
              label: 'Bathroom with shower',
              type: 'boolean',
            }, 
            {
              option: 'kitchen',
              label: 'Kitchen',
              type: 'boolean',
            }, 
            {
              option: 'livingRoom',
              label: 'Living room',
              type: 'boolean',
            },
            {
              option: 'separateBedroom',
              label: 'Separate bedroom',
              type: 'boolean',
            },
            {
              option: 'laundryRoom',
              label: 'Laundry room',
              type: 'boolean',
            }, 
            {
              option: 'sharedBunkHouse', 
              label: 'Shared bunkhouse',
              type: 'boolean',
            }, 
            {
              option: 'petFriendly',
              label: 'Pet friendly',
              type: 'boolean',
            },
          ]
        }
      },
      {
        key: 'hasOverpasses',
        label: 'Overpasses',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Low Overpasses in the local area',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Transport Filters
  {
    category: 'horse-transportation',
    filters: [
      {
        key: 'videoVerified',
        label: 'Video verified',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Video verified',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'activeDotMc',
        label: 'Active DOT/MC number',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Active DOT/MC number',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'cargoInsurance',
        label: 'Insurance coverage for cargo',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Cargo insurance',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'trailerType',
        label: 'Trailer type',
        type: 'enum',
        options: [
          { option: 'enclosed', label: 'Enclosed' },
          { option: 'stock', label: 'Stock' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Trailer type',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'trailerLoadType',
        label: 'Load type',
        type: 'enum',
        options: [
          { option: 'straight', label: 'Straight' },
          { option: 'slant', label: 'Slant' },
          { option: 'stock', label: 'Stock' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Load type',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'ceilingHeight',
        label: 'Ceiling height',
        type: 'enum',
        options: [
          { option: '7ft', label: '7ft' },
          { option: '8ft', label: '8ft' },
          { option: '9ft', label: '9ft' },
          { option: '10ft', label: '10ft' },
          { option: '10ft+', label: '10ft+' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Ceiling height',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasRamp',
        label: 'Has ramp',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Has ramp',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasLoadingRamp',
        label: 'Has loading ramp',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Has loading ramp',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasBoxStalls',
        label: 'Has box stalls/stocks',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Has box stalls/stocks',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasDriverSetup',
        label: 'Has driver setup',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Has driver setup',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'nightlyOffTrailer',
        label: 'Nightly, off trailer',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Nightly off trailer',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'requireHealthCertCoggins',
        label: 'Require Health Cert and Coggins',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Requires health cert and coggins',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'requireDeposit',
        label: 'Require deposit',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Requires deposit',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'paymentPlans',
        label: 'Payment plans',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Offers payment plans',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'transportBlmHorses',
        label: 'BLM horses',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Transports BLM horses',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'transportMexico',
        label: 'Mexico transport',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Transports to Mexico',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'transportCanada',
        label: 'Canada transport',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Transports to Canada',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  {
    category: 'rv-truck-trailerWash',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'mobileServices',
        label: 'Mobile services',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Mobile services',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'radiusOf',
        label: 'Service radius',
        type: 'enum',
        options: [
          {
            option: '0 miles',
            label: '0 miles',
          },
          {
            option: '10 miles',
            label: '10 miles',
          },
          {
            option: '25 miles',
            label: '25 miles',
          },
          {
            option: '50 miles',
            label: '50 miles',
          },
          {
            option: '75 miles',
            label: '75 miles',
          },
          {
            option: '75+ miles',
            label: '75+ miles',
          }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Service radius',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'hasBrickAndMortarGarage',
        label: 'Has brick and mortar garage',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Has brick and mortar garage',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'selfServeOrWashCrew',
        label: 'Self-serve or wash crew',
        type: 'enum',
        options: [
          {
            option: 'none',
            label: 'None',
          },
          {
            option: 'Self serve',
            label: 'Self serve',
          },
          {
            option: 'Wash crew',
            label: 'Wash crew',
          },
          {
            option: 'Both',
            label: 'Both',
          }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Self-serve or wash crew',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Tack Shop Filters
  {
    category: 'tack-shop-farm-supplies',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Tire Shop Filters
  {
    category: 'tire-shop',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'mobileServices',
        label: 'Mobile services',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Mobile services',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'radiusOf',
        label: 'Service radius',
        type: 'enum',
        options: [
          { option: '0-10', label: '0-10 miles' },
          { option: '10-25', label: '10-25 miles' },
          { option: '25-50', label: '25-50 miles' },
          { option: '50-75', label: '50-75 miles' },
          { option: '75+', label: '75+ miles' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Service radius',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'services',
        label: 'Services',
        type: 'multi-enum',
        options: [
          { option: 'tire-repair', label: 'Tire Repair' },
          { option: 'tire-replacement', label: 'Tire Replacement' },
          { option: 'wheel-alignment', label: 'Wheel Alignment' },
          { option: 'brake-service', label: 'Brake Service' },
          { option: 'suspension', label: 'Suspension' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Services',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any'
        }
      },
      {
        key: 'brickAndMortar',
        label: 'Brick and Mortar',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Brick and Mortar location',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Trailer Repair Filters
  {
    category: 'repair',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'mobileServices',
        label: 'Mobile services',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Mobile services',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'radiusOf',
        label: 'Service radius',
        type: 'enum',
        options: [
          { option: '0 miles', label: '0-10 miles' },
          { option: '10 miles', label: '10-25 miles' },
          { option: '25 miles', label: '25-50 miles' },
          { option: '50 miles', label: '50-75 miles' },
          { option: '75+', label: '75+ miles' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Service radius',
          filterType: 'SelectSingleFilter'
        }
      },
    ]
  },
  {
    category: 'truck-stop-gas-station',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'trailer-accessible',
        label: 'Trailer accessible',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Trailer accessible',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'trailer-up-to-what-size',
        label: 'Trailer up to what size',
        type: 'enum',
        options: [
          {
            option: 'up-to-25ft',
            label: 'Up To 25ft',
          },
          {
            option: 'up-to-39ft',
            label: 'Up To 39ft',
          },
          {
            option: '39ft-or-larger',
            label: '39ft Or Larger',
          }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Trailer up to what size',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'amenities',
        label: 'Amenities',
        type: 'multi-enum',
        options: [
          {
            option: 'potable-water',
            label: 'Potable Water',
          },
          {
            option: 'showers',
            label: 'Showers',
          },
          {
            option: 'convenience-store-food',
            label: 'Convenience Store Food',
          },
          {
            option: 'sit-down-restaurant',
            label: 'Sit Down Restaurant',
          },
          {
            option: 'fast-food',
            label: 'Fast Food Chain',
          },
          {
            option: 'laundry',
            label: 'Laundry',
          }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Amenities',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any'
        }
      }
    ]
  },
  {
    category: 'veterinary-clinic',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Open 24h a day',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Open 24h a day',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isHolidayOpen',
        label: 'Holiday hours',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Holiday hours',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'makeFarmCalls',
        label: 'Makes farm calls',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Makes farm calls',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'farmCallRadius',
        label: 'Farm call radius',
        type: 'enum',
        options: [
          { option: '0 miles', label: '0 miles' },
          { option: '10 miles', label: '10 miles' },
          { option: '25 miles', label: '25 miles' },
          { option: '50 miles', label: '50 miles' },
          { option: '75 miles', label: '75 miles' },
          { option: '75+ miles', label: '75+ miles' }
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Farm call radius',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'abilityToIssueCoggins',
        label: 'Ability to issue Coggins',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Ability to issue Coggins',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'abilityToIssueHealthCertificate',
        label: 'Ability to issue Health Certificate',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'primary',
          label: 'Ability to issue Health Certificate',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Hours of Operation Filters - Universal across all categories
  {
    category: 'hours-operation',
    filters: [
      {
        key: 'isOpen24Hours',
        label: 'Is open 24/7',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open 24/7',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isOpenMonday',
        label: 'Is open Monday',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open Monday',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isOpenTuesday',
        label: 'Is open Tuesday',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open Tuesday',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isOpenWednesday',
        label: 'Is open Wednesday',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open Wednesday',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isOpenThursday',
        label: 'Is open Thursday',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open Thursday',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isOpenFriday',
        label: 'Is open Friday',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open Friday',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isOpenSaturday',
        label: 'Is open Saturday',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open Saturday',
          filterType: 'SelectSingleFilter'
        }
      },
      {
        key: 'isOpenSunday',
        label: 'Is open Sunday',
        type: 'boolean',
        filterConfig: {
          indexForSearch: true,
          group: 'hours',
          label: 'Is open Sunday',
          filterType: 'SelectSingleFilter'
        }
      }
    ]
  },
  // Holidays Filters - Universal across all categories
  {
    category: 'holidays',
    filters: [
      {
        key: 'holidays',
        label: 'Closed on holidays',
        type: 'multi-enum',
        options: [
          {
            option: 'new-years-eve',
            label: 'New Years Eve',
          },
          {
            option: 'new-years-day',
            label: 'New Years Day',
          },
          {
            option: 'easter',
            label: 'Easter',
          },
          {
            option: 'memorial-day',
            label: 'Memorial Day',
          },
          {
            option: '4th-of-july',
            label: '4th of July',
          },
          {
            option: 'labor-day',
            label: 'Labor Day',
          },
          {
            option: 'thanksgiving',
            label: 'Thanksgiving',
          },
          {
            option: 'christmas-eve',
            label: 'Christmas Eve',
          },
          {
            option: 'christmas-day',
            label: 'Christmas Day',
          },
        ],
        filterConfig: {
          indexForSearch: true,
          group: 'holidays',
          label: 'Closed on holidays',
          filterType: 'enumMultipleFilter',
          searchMode: 'has_any'
        }
      }
    ]
  },
];

///////////////////////////////////////////////////////////////////////
// Configurations related to listing types and transaction processes //
///////////////////////////////////////////////////////////////////////

// A presets of supported listing configurations
//
// Note 1: The listingTypes come from listingTypes asset nowadays by default.
//         To use this built-in configuration, you need to change the overwrite from configHelper.js
//         (E.g. use mergeDefaultTypesAndFieldsForDebugging func)
// Note 2: transaction type is part of listing type. It defines what transaction process and units
//         are used when transaction is created against a specific listing.

/**
 * Configuration options for listing experience:
 * - listingType:         Unique string. This will be saved to listing's public data on
 *                        EditListingWizard.
 * - label                Label for the listing type. Used as microcopy for options to enum
 *                        listing type in EditListingWizard.
 * - transactionType      Set of configurations how this listing type will behave when transaction is
 *                        created.
 *   - process              Transaction process.
 *                          The process must match one of the processes that this client app can handle
 *                          (check src/util/transactions/transaction.js) and the process must also exists in correct
 *                          marketplace environment.
 *   - alias                Valid alias for the aforementioned process. This will be saved to listing's
 *                          public data as transctionProcessAlias and transaction is initiated with this.
 *   - unitType             Unit type is mainly used as pricing unit. This will be saved to
 *                          transaction's protected data.
 *                          Recommendation: don't use same unit types in completely different processes
 *                          ('item' sold should not be priced the same as 'item' booked).
 * - stockType            This is relevant only to listings using default-purchase process.
 *                        If set to 'oneItem', stock management is not showed and the listing is
 *                        considered unique (stock = 1).
 *                        Possible values: 'oneItem', 'multipleItems', 'infiniteOneItem', and 'infiniteMultipleItems'.
 *                        Default: 'multipleItems'.
 * - availabilityType     This is relevant only to listings using default-booking process.
 *                        If set to 'oneSeat', seat management is not showed and the listing is
 *                        considered per person (seat = 1).
 *                        Possible values: 'oneSeat' and 'multipleSeats'.
 *                        Default: 'oneSeat'.
 * - defaultListingFields These are tied to transaction processes. Different processes have different flags.
 *                        E.g. default-inquiry can toggle price and location to true/false value to indicate,
 *                        whether price (or location) tab should be shown. If defaultListingFields.price is not
 *                        explicitly set to _false_, price will be shown.
 *                        If the location or pickup is not used, listing won't be returned with location search.
 *                        Use keyword search as main search type if location is not enforced.
 *                        The payoutDetails flag allows provider to bypass setting of payout details.
 *                        Note: customers can't order listings, if provider has not set payout details! Monitor
 *                        providers who have not set payout details and contact them to ensure that they add the details.
 */

export const listingTypes = [
  {
    listingType: 'daily-booking',
    label: 'Daily booking',
    transactionType: {
      process: 'default-booking',
      alias: 'default-booking/release-1',
      unitType: 'day',
    },
    availabilityType: 'oneSeat',
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },
  // // Here are some examples for other listingTypes
  // // TODO: SearchPage does not work well if both booking and product selling are used at the same time
  // {
  //   listingType: 'nightly-booking',
  //   label: 'Nightly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'night',
  //   },
  // },
  // {
  //   listingType: 'hourly-booking',
  //   label: 'Hourly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'hour',
  //   },
  // },
  // {
  //   listingType: 'product-selling',
  //   label: 'Sell bicycles',
  //   transactionType: {
  //     process: 'default-purchase',
  //     alias: 'default-purchase/release-1',
  //     unitType: 'item',
  //   },
  //   stockType: 'multipleItems',
  //   defaultListingFields: {
  //     shipping: true,
  //     pickup: true,
  //     payoutDetails: true,
  //   },
  // },
  // {
  //   listingType: 'inquiry',
  //   label: 'Inquiry',
  //   transactionType: {
  //     process: 'default-inquiry',
  //     alias: 'default-inquiry/release-1',
  //     unitType: 'inquiry',
  //   },
  //   defaultListingFields: {
  //     price: false,
  //     location: true,
  //   },
  // },
];

// SearchPage can enforce listing query to only those listings with valid listingType
// However, it only works if you have set 'enum' type search schema for the public data fields
//   - listingType
//
//  Similar setup could be expanded to 2 other extended data fields:
//   - transactionProcessAlias
//   - unitType
//
// Read More:
// https://www.sharetribe.com/docs/how-to/manage-search-schemas-with-flex-cli/#adding-listing-search-schemas
export const enforceValidListingType = false;
/*
export const SCHEMA_TYPE_ENUM = 'enum';
export const SCHEMA_TYPE_MULTI_ENUM = 'multi-enum';
export const SCHEMA_TYPE_TEXT = 'text';
export const SCHEMA_TYPE_LONG = 'long';
export const SCHEMA_TYPE_BOOLEAN = 'boolean';
export const SCHEMA_TYPE_YOUTUBE = 'youtubeVideoUrl';
 */
export const amenities = [
  {
    key: 'horse-hotel',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'healthCertificate',
        label: 'Current Health Certificate and Coggins',
        questions: [
          {
            key: 'healthCertificate',
            label: 'Do you require current health certificate (less than 30 days of arrival) and coggins (less than 12 months of arrival).',
            type: 'boolean',
            required: true,
          },
          {
            key: 'proofPriorArrival',
            label: 'Proof must be shown prior to arrival',
            type: 'boolean',
            required: false,
            dependance: 'healthCertificate',
          },
          {
            key: 'sendProofTo',
            label: 'Send proof of documents to:',
            type: 'text',
            required: false,
            dependance: 'proofPriorArrival',
          }
        ]
      },
      {
        key: 'afterHoursArrivals',
        label: 'Reservation Process',
        questions: [
          {
            key: 'afterHoursArrivals',
            label: 'Are after hours arrivals accepted with prior notice?',
            type: 'boolean',
            required: true,
          },

          {
            key: 'lateArrivalFee',
            label: 'Do you have a late arrival fee?',
            type: 'boolean',
            required: true,
            dependance: 'afterHoursArrivals',
          },
          {
            key: 'lateArrivalFeeAmount',
            label: 'Fee',
            type: 'price',
            required: false,
            dependance: 'lateArrivalFee',
          },
          {
            key: 'walkInsWelcome',
            label: 'Walk-ins Welcome?',
            type: 'boolean',
            required: false,
          },
          {
            key: 'arrivalNotice',
            label: 'How much notice would you like for arrival? (Hours or minutes)',
            type: 'text',
            required: true,
          },
          {
            key: 'preferredContactMethod',
            label: 'Preferred method of contact',
            type: 'text',
            required: true,
          }
        ]
      },
      {
        key: 'onsiteStaff',
        label: 'On-site Staff',
        questions: [
          {
            key: 'onsiteStaff',
            label: 'On-site Staff',
            type: 'boolean',
            required: false,
          }
        ]
      },
      {
        key: 'trailerSize',
        label: 'Trailer Size Accommodation',
        questions: [
          {
            key: 'trailerSizeThatCanAccomodate',
            label: 'What size trailer can you accommodate?',
            type: 'enum',
            required: false,
            options: [
              {
                option: 'up-to-25ft',
                label: 'Up To 25ft',
              },
              {
                option: 'up-to-39ft',
                label: 'Up To 39ft',
              },
              {
                option: '39ft-or-larger',
                label: '39ft Or Larger',
              },
            ]
          }
        ]
      },
      {
        key: 'stalls',
        label: 'Stalls',
        noSpace: true,
        questions: [
          {

          }
        ]
      },
      {
        key: 'indoorStalls',
        label: '',
        noSpace: true,
        questions: [
          {
            key: 'hasIndoorStalls',
            label: 'Indoor Stalls',
            type: 'boolean',
            required: false,
            isCheckbox: true,
          },
          {
            key: 'indoorStallPricePerHorse',
            label: 'Price per Horse',
            type: 'price',
            required: true,
            dependance: 'hasIndoorStalls',
          },
          {
            key: 'numberOfStalls',
            label: 'Number of Stalls',
            type: 'number',
            required: false,
            dependance: 'hasIndoorStalls',
            placeholder: 'Enter number of stalls',
          },

          {
            key: 'typesOfStallsIndoor',
            label: 'Types of Stalls',
            type: 'multi-enum',
            required: false,
            dependance: 'hasIndoorStalls',
            options: [
              {
                label: 'Wood walls',
                option: 'woodWalls',
              },
              {
                label: 'Cement Walls',
                option: 'cementWalls',
              },
              {
                label: 'Pipe Dividers',
                option: 'pipeDividers',
              },
              {
                label: 'Stud Stalls',
                option: 'studStalls',
              },
            ],
          },
          {
            key: 'stallSize',
            label: 'Stall Size  ___  ft  by ____  ft',
            type: 'text',
            required: false,
            dependance: 'hasIndoorStalls',
            placeholder: 'Enter stall size',
          },
        ],
      },
      {
        key: 'outdoorStalls',
        label: '',
        noSpace: true,
        questions: [
          {
            key: 'hasOutdoorStalls',
            label: 'Outdoor Stalls',
            type: 'boolean',
            required: false,
            isCheckbox: true,
          },
          {
            key: 'outdoorStallPricePerHorse',
            label: 'Price per Horse',
            type: 'price',
            required: true,
            dependance: 'hasOutdoorStalls',
          },
          {
            key: 'outdoorNumberOfStalls',
            label: 'Number of Stalls',
            type: 'number',
            required: false,
            dependance: 'hasOutdoorStalls',
            placeholder: 'Enter number of stalls',
          },
          {
            key: 'outdoorStallSize',
            label: 'Stall Size  ___  ft  by ____  ft',
            type: 'text',
            required: false,
            dependance: 'hasOutdoorStalls',
            placeholder: 'Enter stall size',
          },
          {
            key: 'outdoorTypesOfStalls',
            label: 'Types of Stalls',
            type: 'multi-enum',
            required: false,
            dependance: 'hasOutdoorStalls',
            options: [
              {
                label: 'Wood walls',
                option: 'woodWalls',
              },
              {
                label: 'Pipe Dividers',
                option: 'pipeDividers',
              },
            ],
          },
          {
            key: 'outdoorCoveredStalls',
            label: 'Covered Stalls',
            type: 'boolean',
            dependance: 'hasOutdoorStalls',
            required: false,
          },
        ],
      },
      {
        key: 'pastureBoarding',
        label: '',
        noSpace: true,
        questions: [
          {
            key: 'pastureBoarding',
            label: 'Pasture Boarding',
            type: 'boolean',
            required: false,
            isCheckbox: true,
          },
          {
            key: 'pasturePricePerHorse',
            label: 'Price per Horse',
            type: 'price',
            required: true,
            dependance: 'pastureBoarding',
          },
          {
            key: 'typesOfFencing',
            label: 'Types of Fencing',
            type: 'multi-enum',
            required: false,
            dependance: 'pastureBoarding',
            options: [
              {
                label: 'Wood Fencing',
                option: 'woodFencing',
              },
              {
                label: 'Pipe Fencing',
                option: 'pipeFencing',
              },
              {
                label: 'Electrical Fencing',
                option: 'electricalFencing',
              },
              {
                label: 'Barb Wire',
                option: 'barbWire',
              },
            ],
          },
          {
            key: 'areHorsesSeparated',
            label: 'Are the horses separated?',
            type: 'boolean',
            required: false,
            dependance: 'pastureBoarding',
          },
          {
            key: 'pastureSize',
            label: 'How big is the pasture each horse would be in?',
            type: 'text',
            required: false,
            dependance: 'pastureBoarding',
          }
        ]
      },
      {
        key: 'arenas',
        label: '',
        noSpace: true,
        questions: [
          {
            key: 'arenas',
            label: 'Arenas',
            type: 'boolean',
            required: false,
            isCheckbox: true,
          },
          {
            key: 'hasIndoorArena',
            label: 'Has Indoor Arena?',
            type: 'boolean',
            required: false,
            dependance: 'arenas',
          },
          {
            key: 'indoorArenaPricePerHorse',
            label: 'Price per Horse Indoor Arena',
            type: 'price',
            required: true,
            dependance: 'hasIndoorArena',
          },
          {
            key: 'hasOutdoorArena',
            label: 'Has Outdoor Arena?',
            type: 'boolean',
            required: false,
            dependance: 'arenas',
          },
          {
            key: 'outdoorArenaPricePerHorse',
            label: 'Price per Horse Outdoor Arena',
            type: 'price',
            required: true,
            dependance: 'hasOutdoorArena',
          }
        ]
      },
      {
        key: 'muckTrailerArea',
        label: 'Area to Muck Trailer',
        topMargin: true,
        questions: [
          {
            key: 'muckTrailerArea',
            label: 'Do you have an area to muck the trailer?',
            type: 'boolean',
            required: false,
          },
          {
            key: 'extraFeeMuckTrailerArea',
            label: 'Is there an extra fee?',
            type: 'boolean',
            required: false,
            dependance: 'muckTrailerArea',
          },
          {
            key: 'feeAmount',
            label: 'Fee',
            type: 'price',
            required: false,
            dependance: 'extraFee',
            dependance: 'extraFeeMuckTrailerArea'
          },
          {
            key: 'muckPitInstructions',
            label: 'Please provide instructions on where the muck pit is located?',
            type: 'textarea',
            required: false,
            dependance: 'muckTrailerArea',
          }
        ]
      },

      {
        key: 'heatedBarns',
        label: 'Barns are heated',
        questions: [
          {
            key: 'heatedBarns',
            label: 'Barns are heated in the winter',
            type: 'boolean',
            required: false,
          }
        ]
      },

      {
        key: 'waterAccess',
        label: 'Water Access',
        questions: [
          {
            key: 'waterAccess',
            label: 'Water Access (please select all that apply)',
            type: 'multi-enum',
            required: true,
            options: [
              {
                label: 'Auto waterers',
                option: 'autoWaterers',
              },
              {
                label: 'Buckets are provided',
                option: 'bucketsProvided',
              },
              {
                label: 'Must provide your own buckets',
                option: 'mustProvideYourOwnBuckets',
              },
              {
                label: 'No water access. Must provide your own water source.',
                option: 'noWaterAccess',
              },
            ]
          }
        ]
      },
      {
        key: 'hay',
        label: 'Hay',
        questions: [
          {
            key: 'hayIncluded',
            label: 'Hay is included with stay',
            type: 'boolean',
            required: true,
          },
          {
            key: 'typeOfHay',
            label: 'Type of Hay',
            type: 'text',
            required: false,
            dependance: 'hayIncluded',
          },
          {
            key: 'hayAvailableForPurchase',
            label: 'Hay is available for purchase',
            type: 'boolean',
            required: false,
          },
          {
            key: 'hayTypes',
            label: 'Types Of Hay',
            type: 'repeater',
            required: true,
            dependance: 'hayAvailableForPurchase',
            sub_fields: [
              {
                key: 'hayType',
                label: 'Hay Type',
                type: 'text',
                required: false,
                placeholder: '',
              },
              {
                key: 'hayPricePerBale',
                label: 'Price per Bale',
                type: 'price',
                required: false,
                placeholder: '',
              },
            ],
          },
        ]
      },
      {
        key: 'bedding',
        label: 'Bedding',
        questions: [
          {
            key: 'typeOfBedding',
            label: 'Type of Bedding used in stalls',
            type: 'text',
            required: true,
          },
          {
            key: 'beddingIncluded',
            label: 'Is Bedding included in your rate?',
            type: 'boolean',
            required: false,
          },
          {
            key: 'pricePerBedding',
            label: 'Bedding is an additional fee of',
            type: 'price',
            required: false,
            dependance: 'beddingIncluded',
            dependanceValue: false,
          },
          {
            key: 'cleaningIncluded',
            label: 'Is cleaning the stall included with your rate?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'beddingCleaningFee',
            label: 'How much is it to clean the stall?',
            type: 'price',
            required: false,
            dependance: 'cleaningIncluded',
            dependanceValue: false,
          },
          {
            key: 'beedingAdditionalInformation',
            label: 'Additional Information',
            type: 'textarea',
            required: false,
          }
        ]
      },
      {
        key: 'shavings',
        label: 'Shavings',
        questions: [
          {
            key: 'sellShavings',
            label: 'Do you sell Shavings?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'pricePerBag',
            label: 'Price per Bag',
            type: 'price',
            required: false,
            dependance: 'sellShavings',
          }
        ]
      },
      {
        key: 'straw',
        label: 'Straw',
        questions: [
          {
            key: 'sellStraw',
            label: 'Do you sell straw?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'pricePerBaleStraw',
            label: 'Price per Bale',
            type: 'price',
            dependance: 'sellStraw',
            required: false,
          }
        ]
      },
      {
        key: 'trackHorses',
        label: 'Track Horses',
        questions: [
          {
            key: 'trackHorses',
            label: 'Do you accept track horses?',
            type: 'boolean',
            required: false,
          }
        ]
      },
      {
        key: 'draftsPercherons',
        label: 'Drafts/Percherons',
        questions: [
          {
            key: 'draftsPercherons',
            label: 'Do you accept drafts/percherons?',
            type: 'boolean',
            required: false,
          }
        ]
      },
      {
        key: 'trailerDrop',
        label: 'Trailer drop',
        questions: [
          {
            key: 'trailer',
            label: 'Do you allow visitors to drop their trailer?  ',
            type: 'boolean',
            required: true,
          },
          {
            key: 'trailerDropAdditionalFee',
            label: 'Is there an additional fee?',
            type: 'boolean',
            required: false,
            dependance: 'trailer',
          },
          {
            key: 'priceTrailerDrop',
            label: 'Price Per Night',
            type: 'price',
            required: false,
            dependance: 'trailerDropAdditionalFee',
          },
          {
            key: 'trailerAdditionalInformation',
            label: 'Additional Information',
            type: 'textarea',
            required: false,
            dependance: 'trailer',
          }
        ]
      },
      {
        key: 'rvHookUp',
        label: 'RV Hookup',
        questions: [
          {
            key: 'rvHookUp',
            label: 'RV Hookup',
            type: 'boolean',
            required: false,
          },
          {
            key: 'amps',
            label: 'Amps',
            type: 'text',
            required: false,
            dependance: 'rvHookUp',
          },
          {
            key: 'numberOfHookUps',
            label: '# Of Hookups Available',
            type: 'number',
            required: false,
            dependance: 'rvHookUp',
          },
          {
            key: 'rvHookUpAdditionalFee',
            label: 'Is there an additional fee?',
            type: 'boolean',
            required: false,
            dependance: 'rvHookUp',
          },
          {
            key: 'priceRVHookUp',
            label: 'Price per night',
            type: 'price',
            required: false,
            dependance: 'rvHookUpAdditionalFee',
          }
        ]
      },
      {
        key: 'bunkHouse',
        label: 'Bunk House/Sleep Accommodations',
        questions: [
          {
            key: 'hasBunkHouse',
            label: 'Do you have bunk house/sleep accommodations?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'ratePerNight',
            label: 'Rate Per Night',
            type: 'price',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'sleeps',
            label: 'Sleeps',
            type: 'text',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'bathrooms',
            label: 'Bathrooms',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'bathroomWithShower',
            label: 'Bathroom W/ Shower',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'kitchen',
            label: 'Kitchen',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'livingRoom',
            label: 'Living Room',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'separateBedroom',
            label: 'Separate Bedroom',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'numberOfSeparateBedrooms',
            label: 'How many bedrooms?',
            type: 'number',
            dependance: 'separateBedroom',
            required: false,
          },
          {
            key: 'laundryRoom',
            label: 'Laundry Room',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'sharedBunkHouse',
            label: 'Shared bunk house with other guests',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'petFriendly',
            label: 'Pet Friendly?',
            type: 'boolean',
            dependance: 'hasBunkHouse',
            required: false,
          },
          {
            key: 'requirePetDeposit',
            label: 'Do you require a pet deposit?',
            type: 'boolean',
            required: false,
            dependance: 'petFriendly',
          },
          {
            key: 'petDepositAmount',
            label: 'Deposit Amount',
            type: 'price',
            dependance: 'requirePetDeposit',
            required: false,
          },
          {
            key: 'petAdditionalFees',
            label: 'Is there an additional fee for pets?',
            type: 'boolean',
            required: false,
            dependance: 'petFriendly',
          },
          {
            key: 'petAdditionalFee',
            label: 'Additional Fee',
            type: 'price',
            required: false,
            dependance: 'petAdditionalFees',
          }
        ]
      },
      {
        key: 'additionalInformation',
        label: 'Facility Instructions',
        questions: [
          {
            key: 'facilityInstructions',
            label: 'Facility Instructions',
            type: 'textarea',
            required: false,
          },
          {
            key: 'are_there_bridges_low_overpasses_that_trailers_may_not_be_able_to_pass_through_nearby',
            label: 'Are There Bridges/Low Overpasses That Trailers May Not Be Able To Pass Through Nearby?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'instructions',
            label: 'Instructions',
            type: 'textarea',
            required: false,
            placeholder: '',
            dependance: 'are_there_bridges_low_overpasses_that_trailers_may_not_be_able_to_pass_through_nearby',
          },
        ]
      },
    ]
  },
  {
    key: 'horse-transportation',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'horse_transportation',
        title: 'Horse Transportation General Information',
        questions: [
          {
            key: 'active_dot_mc_number',
            label: 'Active DOT/MC Number',
            type: 'boolean',
            required: true,
          },
          {
            key: 'dot_num',
            label: 'DOT #',
            type: 'text',
            required: false,
            placeholder: '',
            dependance: 'active_dot_mc_number',
          },
          {
            key: 'mc_num',
            label: 'MC #',
            type: 'text',
            required: false,
            placeholder: '',
            dependance: 'active_dot_mc_number',
          },
          {
            key: 'insurance_coverage_for_cargo_available',
            label: 'Insurance Coverage For Cargo Available',
            type: 'boolean',
            required: true,
            dependance: 'active_dot_mc_number',
          },
          {
            key: 'insurance_coverage_for_cargo',
            label: 'Insurance Coverage For Cargo',
            type: 'text',
            required: false,
            placeholder: 'Up To',
            dependance: 'insurance_coverage_for_cargo_available',
          }
        ],
      },
      {
        key: 'trucks',
        title: 'Trucks',
        questions: [
          {
            key: 'truck',
            label: 'Truck',
            type: 'repeater',
            required: false,
            sub_fields: [
              {
                key: 'truck_year',
                label: 'Year',
                type: 'text',
                required: true,
                placeholder: '',
              },
              {
                key: 'truck_make',
                label: 'Make',
                type: 'text',
                required: true,
                placeholder: '',
              },
              {
                key: 'truck_model',
                label: 'Model',
                type: 'text',
                required: true,
                placeholder: '',
              },
            ],
          },
        ]
      },
      {
        key: 'trailers',
        title: 'Trailers',
        questions: [
          {
            key: 'trailer',
            label: 'Trailer',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'trailer_year',
                label: 'Year',
                type: 'text',
                required: true,
                placeholder: '',
              },
              {
                key: 'enclosed_or_stock',
                label: 'Enclosed or Stock',
                type: 'enum',
                required: true,
                options: [
                  {
                    option: 'enclosed-trailer',
                    label: 'Enclosed Trailer',
                  },
                  {
                    option: 'stock-trailer',
                    label: 'Stock Trailer',
                  },
                ]
              },
              {
                key: 'goose_or_bumper',
                label: 'Goose or Bumper',
                type: 'enum',
                required: true,
                options: [
                  {
                    option: 'goose-neck',
                    label: 'Goose Neck',
                  },
                  {
                    option: 'bumper-pull',
                    label: 'Bumper Pull',
                  },
                ]
              },
              {
                key: 'straight_or_slant_or_stock',
                label: 'Straight or Slant or Stock',
                type: 'enum',
                required: true,
                options: [
                  {
                    option: 'straight-load',
                    label: 'Straight Load',
                  },
                  {
                    option: 'slant-load',
                    label: 'Slant Load',
                  },
                  {
                    option: 'stock-trailer',
                    label: 'Stock Trailer',
                  },
                ]
              },
              {
                key: 'trailer_length',
                label: 'Trailer Length (ft)',
                type: 'text',
                required: true,
                placeholder: '',
              },
              {
                key: 'trailer_height',
                label: 'Ceiling Height (ft)',
                type: 'text',
                required: true,
                placeholder: '',
              },
              {
                key: 'loading_ramp',
                label: 'Loading Ramp',
                type: 'boolean',
                required: true,
              },
              {
                key: 'rear_loading_option',
                label: 'Rear Loading Option',
                type: 'boolean',
                required: true,
                dependance: 'loading_ramp',
              },
              {
                key: 'side_loading_option',
                label: 'Side Loading Option',
                type: 'boolean',
                required: true,
                dependance: 'loading_ramp',
              },
              {
                key: 'box_stalls',
                label: 'Box Stalls',
                type: 'boolean',
                required: false,
                isCheckbox: true,
                fullWidth: true,
              },
              {
                key: 'approximate_size_of_box_stalls',
                label: 'Approximate Size of Box Stalls (ft)',
                type: 'text',
                required: true,
                placeholder: '',
                dependance: 'box_stalls',
              },
              {
                key: 'no_of_box_stalls_per_trailer',
                label: '# Of Box Stalls Per Trailer',
                type: 'number',
                required: false,
                placeholder: '',
                dependance: 'box_stalls',
              },
              {
                key: 'transport_stalls',
                label: 'Stalls',
                type: 'boolean',
                required: false,
                isCheckbox: true,
                fullWidth: true,
              },
              {
                key: 'approximate_size_of_transport_stalls',
                label: 'Approximate Size of Stalls (ft)',
                type: 'text',
                required: true,
                placeholder: '',
                dependance: 'transport_stalls',
              },
              {
                key: 'no_of_transport_stalls_per_trailer',
                label: '# Of Stalls Per Trailer',
                type: 'number',
                required: false,
                placeholder: '',
                dependance: 'transport_stalls',
              },
              {
                key: 'stalls_and_a_half',
                label: 'Stalls and a Half',
                type: 'boolean',
                required: false,
                isCheckbox: true,
                fullWidth: true,
              },
              {
                key: 'approximate_size_of_stalls_and_a_half',
                label: 'Approximate Size of Stalls and a Half (ft)',
                type: 'text',
                required: true,
                placeholder: '',
                dependance: 'stalls_and_a_half',
              },
              {
                key: 'no_of_stalls_and_a_half_per_trailer',
                label: '# Of Stalls and a Half Per Trailer',
                type: 'number',
                required: false,
                placeholder: '',
                dependance: 'stalls_and_a_half',
              },
            ],
          },
        ]
      },
      {
        key: 'additional_info',
        title: 'Additional Information',
        questions: [
          {
            key: 'drive_team_or_single_driver',
            label: 'Driver Set Up',
            type: 'multi-enum',
            required: true,
            options: [
              {
                option: 'drive-team',
                label: 'Drive Team',
              },
              {
                option: 'single-driver',
                label: 'Single Driver',
              }
            ]
          },
          {
            key: 'nightly_off_trailer_unload_the_horses_layovers',
            label: 'Nightly Off Trailer (Unload The Horses) Layovers',
            type: 'boolean',
            required: true,
          },
          {
            key: 'layovers_are_at_private_designated_boarding_facilities',
            label: 'Layovers Are At Private/Designated Boarding Facilities',
            type: 'boolean',
            required: true,
            dependance: 'nightly_off_trailer_unload_the_horses_layovers',
          },
          {
            key: 'layovers_are_at_public_access_facilities_like_fairgrounds',
            label: 'Layovers Are At Public Access Facilities Like Fairgrounds',
            type: 'boolean',
            required: true,
            dependance: 'nightly_off_trailer_unload_the_horses_layovers',
          },
          {
            key: 'all_horses_on_board_will_have_current_health_certificate_and_coggins',
            label: 'All Horses On Board Will Have Current Health Certificate and Coggins',
            type: 'boolean',
            required: true,
          },
          {
            key: 'are_they_required_to_have_a_health_certificate_and_coggins_regardless_of_whether_they_are_in_state_or_interstate_travel',
            label: 'Are They Required To Have A Health Certificate and Coggins Regardless Of Whether They Are In State or Interstate Travel',
            type: 'boolean',
            required: true,
          },
          {
            key: 'owner_supplies_the_hay',
            label: 'Is the owner required to supply any hay?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'additional_fee_for_hay',
            label: 'Additional Fee For Hay',
            type: 'price',
            required: true,
            placeholder: '',
            dependance: 'owner_supplies_the_hay',
            dependanceValue: false,
          },
          {
            key: 'do_you_carry_a_water_supply_on_board',
            label: 'Do You Carry A Water Supply On Board',
            type: 'true',
            required: false,
          },
          {
            key: 'do_the_horses_have_access_to_hay_and_water_247_while_in_your_care',
            label: 'Do The Horses Have Access To Hay and Water 24/7 While In Your Care',
            type: 'boolean',
            required: true,
          },
          {
            key: 'what_is_your_maximum_daily_drive_time',
            label: 'What Is Your Maximum Daily Drive Time',
            type: 'text',
            required: true,
            placeholder: '',
          },
          {
            key: 'do_you_require_a_deposit',
            label: 'Do You Require A Deposit',
            type: 'boolean',
            required: true,
          },
          {
            key: 'do_you_offer_payment_plans',
            label: 'Do You Offer Payment Plans',
            type: 'boolean',
            required: true,
            options: {
              'Yes': 'Yes',
              'No': 'No',
            },
          },
          {
            key: 'willing_to_transport_blm_horses',
            label: 'Willing To Transport BLM Horses',
            type: 'boolean',
            required: true,
            options: {
              'Yes': 'Yes',
              'No': 'No',
            },
          },
          {
            key: 'transport_available_in_mexico',
            label: 'Transport Available In Mexico',
            type: 'boolean',
            required: true,
            options: {
              'Yes': 'Yes',
              'No': 'No',
            },
          },
          {
            key: 'transport_available_in_canada',
            label: 'Transport Available In Canada',
            type: 'boolean',
            required: true,
            options: {
              'Yes': 'Yes',
              'No': 'No',
            },
          },
          {
            key: 'are_you_a_member_of_any_associations',
            label: 'Are You A Member Of Any Associations',
            type: 'boolean',
            required: true,
          },
          {
            key: 'association_member_of',
            label: 'Association Member Of',
            type: 'repeater',
            required: false,
            sub_fields: [
              {
                key: 'association',
                label: 'Association',
                type: 'text',
                required: true,
                placeholder: '',
              },
            ],
            dependance: 'are_you_a_member_of_any_associations',
          },
        ],
      },
    ],
  },
  {
    key: 'feedStores',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'hay',
        title: '',
        questions: [
          {
            key: 'sellHay',
            label: 'Do You Sell Hay?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'hayTypes',
            label: 'Types Of Hay',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'hayType',
                label: 'Hay Type',
                type: 'text',
                required: false,
                placeholder: '',
              },
              {
                key: 'hayPrice',
                label: 'Price',
                type: 'price',
                required: false,
                placeholder: '',
              },
            ],
            dependance: 'sellHay',
          }
        ]
      }
    ]
  },
  {
    key: 'repair',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'mobile_services',
        label: 'Do you offer Mobile Services? ',
        questions: [
          {
            key: 'mobileServices',
            label: 'Do you offer Mobile Services? ',
            type: 'boolean',
            required: true,
          },
          {
            key: 'radiusOf',
            label: 'Service Radius',
            type: 'enum',
            required: true,
            placeholder: 'Enter Service Radius',
            dependance: 'mobileServices',
            options: [
              {
                option: '0 miles',
                label: '0 Miles',
              },
              {
                option: '10 miles',
                label: '10 Miles',
              },
              {
                option: '25 miles',
                label: '25 Miles',
              },
              {
                option: '50 miles',
                label: '50 Miles',
              },
              {
                option: '75 miles',
                label: '75 Miles',
              },
              {
                option: '75+ miles',
                label: '75+ Miles',
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'auto-diesel-mechanic',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'mobile_services',
        title: 'Mobile Services',
        questions: [
          {
            key: 'mobileServices',
            label: 'Do you offer Mobile Services? ',
            type: 'boolean',
            required: true,
          },
          {
            key: 'radiusOf',
            label: 'Service Radius',
            type: 'enum',
            required: true,
            placeholder: 'Enter the radius of service',
            dependance: 'mobileServices',
            options: [
              {
                option: '0 miles',
                label: '0 miles',
              },
              {
                option: '10 miles',
                label: '10 miles',
              },
              {
                option: '25 miles',
                label: '25 miles',
              },
              {
                option: '50 miles',
                label: '50 miles',
              },
              {
                option: '75 miles',
                label: '75 miles',
              },
              {
                option: '75+ miles',
                label: '75+ miles',
              }
            ]
          },
          {
            key: 'hasDieselMechanic',
            label: 'Do you have diesel mechanics available?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'dieselMechanicCertified',
            label: 'Are your diesel mechanics certified? ',
            type: 'boolean',
            required: false,
            dependance: 'hasDieselMechanic',
          },
          {
            key: 'hasBrickAndMortarGarage',
            label: 'Do you have a Brick and Mortar Garage?',
            type: 'boolean',
            required: true,
          }
        ]
      }
    ]
  },
  {
    key: 'rv-truck-trailerWash',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'mobile_services',
        title: 'Mobile Services',
        questions: [
          {
            key: 'mobileServices',
            label: 'Do you offer Mobile Services? ',
            type: 'boolean',
            required: true,
          },
          {
            key: 'radiusOf',
            label: 'Service Radius',
            type: 'enum',
            required: true,
            placeholder: 'Enter Service Radius',
            dependance: 'mobileServices',
            options: [
              {
                option: '0 miles',
                label: '0 miles',
              },
              {
                option: '10 miles',
                label: '10 miles',
              },
              {
                option: '25 miles',
                label: '25 miles',
              },
              {
                option: '50 miles',
                label: '50 miles',
              },
              {
                option: '75 miles',
                label: '75 miles',
              },
              {
                option: '75+ miles',
                label: '75+ miles',
              }
            ]
          },
          {
            key: 'maximumSizeTruckOrTrailerHeight',
            label: 'Maximum size truck or trailer (height in feet)',
            type: 'text',
            required: true,
            placeholder: 'Enter maximum size truck or trailer (height in feet)',
          },
          {
            key: 'maximumSizeTruckOrTrailerLength',
            label: 'Maximum size truck or trailer (length in feet)',
            type: 'text',
            required: true,
            placeholder: 'Enter maximum size truck or trailer (length in feet)',
          },
          {
            key: 'hasBrickAndMortarGarage',
            label: 'Has brick and mortar garage',
            type: 'boolean',
            required: true,
          },
          {
            key: 'selfServeOrWashCrew',
            label: 'Self serve or wash crew',
            type: 'enum',
            required: false,
            dependance: 'hasBrickAndMortarGarage',
            options: [
              {
                option: 'none',
                label: 'None',
              },
              {
                option: 'Self serve',
                label: 'Self serve',
              },
              {
                option: 'Wash crew',
                label: 'Wash crew',
              },
              {
                option: 'Both',
                label: 'Both',
              }
            ]
          }
        ]
      },
    ]
  },
  {
    key: 'tack-shop-farm-supplies',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },   
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
    ]
  },
  {
    key: 'veterinary-clinic',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'information',
        label: 'Additional Information',
        questions: [
          {
            key: 'makeFarmCalls',
            label: 'Do you make farm calls?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'farmCallRadius',
            label: 'Farm call radius',
            type: 'enum',
            required: true,
            placeholder: 'Enter Service Radius',
            dependance: 'makeFarmCalls',
            options: [
              {
                option: '0 miles',
                label: '0 miles',
              },
              {
                option: '10 miles',
                label: '10 miles',
              },
              {
                option: '25 miles',
                label: '25 miles',
              },
              {
                option: '50 miles',
                label: '50 miles',
              },
              {
                option: '75 miles',
                label: '75 miles',
              },
              {
                option: '75+ miles',
                label: '75+ miles',
              }
            ]
          },
          {
            key: 'abilityToIssueCoggins',
            label: 'Does your clinic have the ability to issue a Coggins?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'turnAroundTimeForCoggins',
            label: 'Turn around time for Coggins (days or hours)',
            type: 'text',
            required: false,
            dependance: 'abilityToIssueCoggins',
          },
          {
            key: 'abilityToIssueHealthCertificate',
            label: 'Does your clinic have the ability to issue a Health Certificate?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'turnAroundTimeForHealthCertificate',
            label: 'Turn around time for health certificate (days or hours)',
            type: 'text',
            required: false,
            dependance: 'abilityToIssueHealthCertificate',
          }
        ]
      }
    ]
  },
  {
    key: 'tire-shop',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          }
        ]
      },
      {
        key: 'mobile_services',
        title: 'Mobile Services',
        questions: [
          {
            key: 'mobileServices',
            label: 'Do you offer Mobile Services? ',
            type: 'boolean',
            required: true,
          },
          {
            key: 'radiusOf',
            label: 'Service Radius',
            type: 'enum',
            required: true,
            placeholder: 'Enter Service Radius',
            dependance: 'mobileServices',
            options: [
              {
                option: '0 miles',
                label: '0 miles',
              },
              {
                option: '10 miles',
                label: '10 miles',
              },
              {
                option: '25 miles',
                label: '25 miles',
              },
              {
                option: '50 miles',
                label: '50 miles',
              },
              {
                option: '75 miles',
                label: '75 miles',
              },
              {
                option: '75+ miles',
                label: '75+ miles',
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'truck-stop-gas-station',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: 'open-hours',
        label: 'Hours of Operation',
        questions: [
          {
            key: 'isOpen24Hours',
            label: 'Are you open 24 hours?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'isOpenMonday',
            label: 'Is open on Monday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'monday',
            label: 'Monday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenMonday',
          },
          {
            key: 'isOpenTuesday',
            label: 'Is open on Tuesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'tuesday',
            label: 'Tuesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenTuesday',
          },
          {
            key: 'isOpenWednesday',
            label: 'Is open on Wednesday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'wednesday',
            label: 'Wednesday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenWednesday',
          },
          {
            key: 'isOpenThursday',
            label: 'Is open on Thursday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'thursday',
            label: 'Thursday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenThursday',
          },
          {
            key: 'isOpenFriday',
            label: 'Is open on Friday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'friday',
            label: 'Friday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenFriday',
          },
          {
            key: 'isOpenSaturday',
            label: 'Is open on Saturday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'saturday',
            label: 'Saturday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSaturday',
          },
          {
            key: 'isOpenSunday',
            label: 'Is open on Sunday?',
            type: 'boolean',
            required: true,
            dependance: 'isOpen24Hours',
            dependanceValue: false
          },
          {
            key: 'sunday',
            label: 'Sunday',
            type: 'openAndCloseTime',
            required: false,
            dependance: 'isOpenSunday',
          },
        ],
      },
      {
        key: 'holiday-open',
        label: 'Holiday Hours',
        questions: [
          {
            key: 'isHolidayOpen',
            label: 'Are you closed for any Holidays?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'holidays',
            label: 'Which Holidays are you closed?',
            type: 'multi-enum',
            required: false,
            dependance: 'isHolidayOpen',
            options: [
              {
                option: 'new-years-eve',
                label: 'New Years Eve',
              },
              {
                option: 'new-years-day',
                label: 'New Years Day',
              },
              {
                option: 'easter',
                label: 'Easter',
              },
              {
                option: 'memorial-day',
                label: 'Memorial Day',
              },
              {
                option: '4th-of-july',
                label: '4th of July',
              },
              {
                option: 'labor-day',
                label: 'Labor Day',
              },
              {
                option: 'thanksgiving',
                label: 'Thanksgiving',
              },
              {
                option: 'christmas-eve',
                label: 'Christmas Eve',
              },
              {
                option: 'christmas-day',
                label: 'Christmas Day',
              },
            ],
          },
        ]
      },
      {
        key: 'payment-methods',
        label: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              }
            ]
          }
        ]
      },
      {
        key: 'additional-information',
        questions: [
          {
            key: 'trailer-accesible',
            label: 'Trailer accessible?',
            type: 'boolean',
            required: true,
          },
          {
            key: 'trailer-up-to-what-size',
            label: 'Trailer up to what size?',
            type: 'enum',
            required: true,
            options: [
              {
                option: 'up-to-25ft',
                label: 'Up To 25ft',
              },
              {
                option: 'up-to-39ft',
                label: 'Up To 39ft',
              },
              {
                option: '39ft-or-larger',
                label: '39ft Or Larger',
              }
            ],
            dependance: 'trailer-accesible'
          },
          {
            key: 'amenities',
            label: 'Amenities',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'potable-water',
                label: 'Potable Water',
              },
              {
                option: 'showers',
                label: 'Showers',
              },
              {
                option: 'convenience-store-food',
                label: 'Convenience Store Food',
              },
              {
                option: 'sit-down-restaurant',
                label: 'Sit Down Restaurant',
              },
              {
                option: 'fast-food',
                label: 'Fast Food Chain',
              },
              {
                option: 'laundry',
                label: 'Laundry',
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'farriers',
    groups: [
      {
        key: 'contact-info',
        label: 'Contact Information',
        questions: [
          {
            key: 'contacts',
            label: 'Contact(s)',
            type: 'repeater',
            required: true,
            sub_fields: [
              {
                key: 'contactName',
                label: 'Contact Name',
                type: 'text',
                required: true,
                placeholder: 'Enter contact name',
              },
              {
                key: 'contactPhone',
                label: 'Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter phone number',
              },
              {
                key: 'contactCellPhone',
                label: 'Cell Phone Number',
                type: 'text',
                required: false,
                placeholder: 'Enter cell phone number',
              },
              {
                key: 'contactEmail',
                label: 'Email Address',
                type: 'text',
                required: false,
                placeholder: 'Enter email address',
              }
            ]
          },
          {
            key: 'website',
            label: 'Website',
            type: 'text',
            required: false,
            placeholder: 'Enter website URL',
          },
          {
            key: 'facebook',
            label: 'Facebook',
            type: 'text',
            required: false,
            placeholder: 'Enter Facebook URL',
          },
          {
            key: 'instagram',
            label: 'Instagram',
            type: 'text',
            required: false,
            placeholder: 'Enter Instagram URL',
          },
          {
            key: 'tiktok',
            label: 'TikTok',
            type: 'text',
            required: false,
            placeholder: 'Enter TikTok URL',
          },
          {
            key: 'twitter',
            label: 'X (Twitter)',
            type: 'text',
            required: false,
            placeholder: 'Enter X/Twitter URL',
          },
          {
            key: 'youtube',
            label: 'YouTube',
            type: 'text',
            required: false,
            placeholder: 'Enter YouTube URL',
          }
        ]
      },
      {
        key: '',
        title: '',
        questions: [
          {
            key: 'payment-methods',
            label: 'Accepted Payment Methods:  (Please select all that apply)',
            type: 'multi-enum',
            required: false,
            options: [
              {
                option: 'cash',
                label: 'Cash',
              },
              {
                option: 'credit-debit-card',
                label: 'Credit/Debit Card',
              },
              {
                option: 'check',
                label: 'Check',
              },
              {
                option: 'paypal',
                label: 'PayPal',
              },
              {
                option: 'square',
                label: 'Square',
              },
              {
                option: 'venmo',
                label: 'Venmo',
              },
              {
                option: 'zelle',
                label: 'Zelle',
              },
              {
                option: 'others',
                label: 'Other',
              },
            ]
          },
          {
            key: 'travelRadius',
            label: 'Travel radius',
            type: 'enum',
            required: true,
            placeholder: 'Please enter the radius you are wiling to travel.',
            options: [
              {
                option: '0 miles',
                label: '0 miles',
              },
              {
                option: '10 miles',
                label: '10 miles',
              },
              {
                option: '25 miles',
                label: '25 miles',
              },
              {
                option: '50 miles',
                label: '50 miles',
              },
              {
                option: '75 miles',
                label: '75 miles',
              },
              {
                option: '75+ miles',
                label: '75+ miles',
              }
            ]
          }
        ]
      }
    ]
  }
]
